import { render, staticRenderFns } from "./DocsCreate.vue?vue&type=template&id=1cabc418&scoped=true&"
import script from "./DocsCreate.vue?vue&type=script&lang=js&"
export * from "./DocsCreate.vue?vue&type=script&lang=js&"
import style0 from "./DocsCreate.vue?vue&type=style&index=0&id=1cabc418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cabc418",
  null
  
)

export default component.exports